import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl w-full bg-black/20 backdrop-blur-sm rounded-lg p-8 border border-gray-600/30">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-white mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
          Privacy Policy
        </h1>
        <p className="text-gray-300">Last updated: September 2025</p>
      </div>

      <div className="space-y-6 text-gray-300">
        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            Information We Collect
          </h2>
          <p className="mb-3">
            We collect information you provide directly to us, such as when you:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Make a donation through our platform</li>
            <li>Submit a help request form</li>
            <li>Contact us for support</li>
            <li>Subscribe to our newsletter</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            How We Use Your Information
          </h2>
          <p className="mb-3">We use the information we collect to:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Process donations and provide receipts</li>
            <li>Review and respond to help requests</li>
            <li>Communicate with you about our programs</li>
            <li>Improve our services and website</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            Information Sharing
          </h2>
          <p className="mb-3">
            We do not sell, trade, or otherwise transfer your personal
            information to third parties without your consent, except:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              To trusted service providers who assist us in operating our
              website
            </li>
            <li>When required by law or to protect our rights</li>
            <li>In connection with a business transfer or acquisition</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            Data Security
          </h2>
          <p>
            We implement appropriate security measures to protect your personal
            information against unauthorized access, alteration, disclosure, or
            destruction. However, no method of transmission over the internet is
            100% secure.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            Children's Privacy
          </h2>
          <p>
            Our services are designed to help children with cancer and their
            families. We take special care to protect the privacy of minors and
            comply with applicable children's privacy laws.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at:
          </p>
          <p className="mt-2 text-blue-400">contact@maxwinsferdakids.org</p>
        </section>
      </div>

      <div className="text-center mt-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white px-8 py-3 rounded-full font-bold text-lg transition-all hover:scale-105 shadow-lg hover:shadow-purple-500/25"
        >
          <span>🏠</span>
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
